export const cmpCountries = ['de', 'us', 'ca', 'pl', 'it', 'es', 'pt', 'ro', 'ua', 'at', 'hr', 'si', 'fr', 'bg'];
